<template>
  <div>
    <div class="content-title">修改密码</div>
    <div class="content-tool"  style="width: 500px;">
      <el-form :model="basicinfo" :rules="rules" label-width="120px">
        <el-form-item prop="oldpasswd" label="旧密码：">
          <el-input type="password" v-model="basicinfo.oldpasswd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newpasswd" label="新密码：">
          <el-input type="password" v-model="basicinfo.newpasswd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="confirmpasswd" label="确认密码：">
          <el-input type="password" v-model="basicinfo.confirmpasswd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePwd">保&nbsp;存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
// import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';
import { passwdHmacSHA1 } from '@/utils';

export default {
  name: 'pwdmodify',
  data() {
    return {
      basicinfo: {
        oldpasswd: '',
        newpasswd: '',
        confirmpasswd: '',
      },
      rules: {
        oldpasswd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newpasswd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmpasswd: [{ required: true, validator: this.confirmPasswdValidator, trigger: 'blur' }],
      },
    };
  },
  methods: {
    changePwd() {
      api.changePwd({
        params: {
          data: {
            uaccount: passwdHmacSHA1(this.basicinfo.oldpasswd),
            upasswd: passwdHmacSHA1(this.basicinfo.newpasswd),
          },
        },
      }).then(() => {
        this.$message({
          message: '密码修改成功',
          type: 'success',
        });
      }).catch(() => {
        eleLoading.close();
        this.$message({
          message: '导入失败，请稍后重试',
          type: 'error',
        });
      });
    },
    confirmPasswdValidator(rule, value, callback) {
      console.log('confirmPasswdValidator: ', value);
      if (!value) {
        return callback(new Error('请输入确认密码'));
      } else if (value !== this.basicinfo.newpasswd) {
        callback(new Error('两次密码输入不一致，请重新输入'));
      } else {
        callback();
      }
      return 0;
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pwdmodify.vue